<template>
  <span :class="$style['wrapper']">
    <input
      v-validate="validateRules"
      :name="name"
      :type="inputType"
      :value="value"
      :class="{
        'input': true,
        'error': errors.has(name)
      }"
      :placeholder="placeholder"
      :autocomplete="name"
      :readonly="readOnly"
      @input="updateValue($event.target.value)"
    >
    <span
      v-if="peekField"
      :class="$style['peek-wrapper']"
      @click="onPeekClick"
    >
      <ds-eye-visible-icon v-if="peekActive" />
      <ds-eye-not-visible-icon v-else />
    </span>
    <span v-if="showErrorBox">
      <span v-if="!showServerError">
        <InputErrorBox
          v-show="errors.has(name)"
          :message="errors.first(name)"
        />
      </span>
      <span v-else>
        <InputErrorBox
          v-show="serverError"
          :message="serverError"
        />
      </span>
    </span>
  </span>
</template>

<script>
import InputErrorBox from "./ds-input-error-box";

export default {
  name: "DsInput",
  inject: ["$validator"],
  components: {
    InputErrorBox
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    placeholder: {
      type: String,
      default: ""
    },
    validateRules: {
      type: String | Object,
      default: ""
    },
    serverError: {
      type: String,
      default: null
    },
    showServerError: {
      type: Boolean,
      default: false
    },
    showErrorBox: {
      type: Boolean,
      default: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    peekField: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      peekActive: false
    };
  },
  computed: {
    inputType: function() {
      return this.peekField && this.peekActive ? "text" : this.type;
    }
  },
  methods: {
    updateValue: function(value) {
      this.$emit("input", value);
    },
    onPeekClick: function() {
      this.peekActive = !this.peekActive;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../scss/_variables.scss";

input[type="text"],
input[type="password"],
input[type="email"],
input[type="tel"] {
  border-radius: $border-radius;
  border: 1px solid $border-color;
  height: $input-height;
  outline: none;
  padding: 0px 10px;
  font-size: $font-small-size;
  width: 100%;
  box-shadow: none;
  background-color: #fff;
  &:active,
  &:focus {
    border-color: $border-color !important;
    box-shadow: none !important;
  }
}
input[readonly] {
  background-color: $silver-dark-color;
}
span.error {
  color: $red-error-color;
}
.error-box {
  display: block !important;
  min-height: 21px;
  padding-top: 2px;
  margin-top: 0px !important;
  font-size: $font-small-size;
}
input.error {
  border-color: $red-error-color;
  &:hover {
    border-color: $red-error-color;
  }
}
</style>
<style lang="scss" module>
.peek-wrapper {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translate(0%, -50%);
}
.wrapper {
  position: relative;
  display: block;
  // height: 100%;
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-input.vue